/* global axios */
import ApiClient from '../ApiClient';

class NexceoLeadFormsAPI extends ApiClient {
  constructor() {
    super('nexceo/lead_forms', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, { lead_form: payload });
  }

  update(id, payload) {
    return axios.put(`${this.url}/${id}`, { lead_form: payload });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  submissions(id, filters = {}) {
    return axios.get(`${this.url}/${id}/submissions`, { params: filters });
  }

  stats(id) {
    return axios.get(`${this.url}/${id}/stats`);
  }

  globalStats() {
    return axios.get(this.url.replace('/lead_forms', '/lead_forms_stats'));
  }
}

export default new NexceoLeadFormsAPI();
